"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copyright 2017-2022 @darwinia/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
// order important in structs... :)

/* eslint-disable sort-keys */
var _default = {
  rpc: {},
  types: {
    RelayHeaderId: 'EthereumBlockNumber',
    // RelayHeaderParcel: 'EthereumRelayHeaderParcel',
    RelayProofs: 'EthereumRelayProofs',
    RelayVotingState: {
      ayes: 'Vec<AccountId>',
      nays: 'Vec<AccountId>'
    },
    RelayAffirmationId: {
      relayHeaderId: 'RelayHeaderId',
      round: 'u32',
      index: 'u32'
    },
    EthereumRelayProofs: {
      ethashProof: 'Vec<EthashProof>',
      mmrProof: 'Vec<H256>'
    }
  }
};
exports.default = _default;